import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Lab from "@/pages/Lab";
import History from "@/pages/History";
import Materials from "@/pages/Materials";
import MaterialDetail from "@/pages/MaterialDetail";
import Scenarios from "@/pages/Scenarios";
import Pjbl from "@/pages/Pjbl";
import Leaderboard from "@/pages/Leaderboard";
import LecturerContent from "@/pages/LecturerContent";
import LecturerGrading from "@/pages/LecturerGrading";
import Admin from "@/pages/Admin";

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/lab" element={<Lab />} />
              <Route
                path="/history"
                element={
                  <ProtectedRoute roles={["student"]}>
                    <History />
                  </ProtectedRoute>
                }
              />
              <Route path="/materials" element={<Materials />} />
              <Route path="/materials/:id" element={<MaterialDetail />} />
              <Route path="/scenarios" element={<Scenarios />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route
                path="/pjbl"
                element={
                  <ProtectedRoute roles={["student"]}>
                    <Pjbl />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lecturer/content"
                element={
                  <ProtectedRoute roles={["lecturer", "admin"]}>
                    <LecturerContent />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lecturer/grading"
                element={
                  <ProtectedRoute roles={["lecturer", "admin"]}>
                    <LecturerGrading />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute roles={["admin"]}>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
